export default __webpack_public_path__ + "static/media/bucket.8e7ef939.svg";